import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import api, { apiErr } from "@/lib/api";
import { Modal, Spinner, Button } from "@/components/common";
import { toast } from "sonner";

export function PayPalPay({ open, onClose, order, onSuccess }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    if (open) { setCfg(null); api.get("/payments/paypal/client-config").then((r) => setCfg(r.data)).catch(() => setCfg({ configured: false })); }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title="Pagamento con PayPal">
      {!cfg ? <Spinner /> : !cfg.configured ? (
        <div className="text-center py-6" data-testid="paypal-not-configured">
          <p className="text-slate-600">PayPal non è ancora configurato dalla piattaforma.</p>
          <p className="text-sm text-slate-400 mt-1">Contatta l'amministratore di sistema per abilitare i pagamenti.</p>
          <Button className="mt-4" onClick={onClose}>Chiudi</Button>
        </div>
      ) : (
        <div>
          <div className="mb-4 p-4 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-between">
            <span className="text-slate-600 text-sm">{order?.label}</span>
            {order?.amount ? <span className="font-bold font-display text-slate-900">€{Number(order.amount).toFixed(2)}</span> : null}
          </div>
          <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "EUR", intent: "capture" }}>
            <PayPalButtons
              style={{ layout: "vertical", shape: "pill", color: "gold" }}
              forceReRender={[order?.amount, order?.label]}
              createOrder={async () => {
                const { data } = await api.post("/payments/paypal/create-order", {
                  kind: order.kind, plan: order.plan, pagamento_id: order.pagamento_id, rata_numero: order.rata_numero,
                });
                return data.order_id;
              }}
              onApprove={async (data) => {
                try {
                  const { data: res } = await api.post("/payments/paypal/capture-order", { order_id: data.orderID });
                  if (res.payment_status === "paid") { toast.success("Pagamento completato!"); onSuccess && onSuccess(); onClose(); }
                  else toast.error("Pagamento non completato");
                } catch (e) { toast.error(apiErr(e)); }
              }}
              onError={() => toast.error("Errore durante il pagamento PayPal")}
            />
          </PayPalScriptProvider>
        </div>
      )}
    </Modal>
  );
}
